/**
 * The four trailing cells of one portal-login row — Status, Enrolment,
 * Granted and Actions — shared by the admin's Portal users modal and the
 * operator portal's own Drivers & vehicles screen, so a login reads, and is
 * acted on, the same way in both.
 *
 * `user` is PortalUsersService's row shape. A revoked login keeps its row
 * but offers no action: there is nothing left to regenerate or revoke.
 */
import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { formatDateTime } from '../../../Utils/timezone';

export default function PortalLoginCells({
  user, busy = false, onRegenerate, onRevoke,
}) {
  return (
    <>
      <td data-label="Status">
        {user.active ? (
          <Badge bg="success">Active</Badge>
        ) : (
          <Badge bg="secondary">Disabled</Badge>
        )}
      </td>
      <td data-label="Enrolment">
        {user.enrolmentPending ? (
          <Badge bg="warning" text="dark">Link outstanding</Badge>
        ) : (
          <span className="text-muted">—</span>
        )}
      </td>
      <td data-label="Granted">
        <div>{formatDateTime(user.createdAt) || '—'}</div>
        {user.createdBy ? (
          <div className="small text-muted">{user.createdBy}</div>
        ) : null}
      </td>
      <td>
        <div className="d-flex gap-1">
          {user.active && (
            <>
              <Button
                variant="primary"
                size="sm"
                onClick={() => onRegenerate(user)}
                disabled={busy}
              >
                <i className="fa fa-qrcode me-1" />
                New link
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={() => onRevoke(user)}
                disabled={busy}
              >
                <i className="fa fa-ban me-1" />
                Revoke
              </Button>
            </>
          )}
        </div>
      </td>
    </>
  );
}
